import { render, staticRenderFns } from "./thread-create.vue?vue&type=template&id=187c1016&"
import script from "./thread-create.vue?vue&type=script&lang=js&"
export * from "./thread-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports